import addCaption from '../Features/Delsystem/_Common/Components/BusinessCollectionComponents/Hocs/addCaption';
import attributVy from '../Features/Delsystem/_Common/Components/BusinessCollectionComponents/attributVy';
import { IObjektVy, IBusinessCollectionProps } from '../Types/ObjektVy';
import { IClientBusinessModel } from '../Types/ClientModelTypes';

/**
Ersätter eventuella strängar med fältvyer
*/
export const handleStringDef = (vyDef: IObjektVy | string): IObjektVy =>
  typeof vyDef === 'string' ? attributVy({ attributeDef: vyDef }) : vyDef;

/**
Skapar komponenten för en vy enligt def och lägger till en rubrikrad ovanför om det inte är en "komponentMedRubrik"
*/
export const vyDefToCaptionedComp =
  (bmod: IClientBusinessModel) =>
  (
    vyDef: IObjektVy | string
  ): React.ComponentType<React.PropsWithChildren<IBusinessCollectionProps>> => {
    const vy = handleStringDef(vyDef);
    const vyComp = vy.def(bmod);
    return vy.info.komponentMedRubrik
      ? vyComp.comp
      : addCaption(vyComp.caption, true)(vyComp.comp);
  };
